<template>
	<div class="mt-3">
		<b-button v-if="$hasPermission('channel.add')" class="float-right" @click="newGroup"
			>Nuevo Grupo</b-button
		>
		<h4>Grupos de Canales</h4>
		<hr />
		<b-form
			@submit="
				evt => {
					evt.preventDefault();
					this.$root.$emit(
						'bv::refresh::table',
						'sales-channel-groups-list'
					);
				}
			"
		>
			<div class="row">
				<b-form-group class="col-2" label="Buscar">
					<b-form-input
						v-model="filters.search"
						type="text"
					/>
				</b-form-group>
				<b-form-group class="col-2" label=".">
					<b-button type="submit" variant="primary"
						>Buscar</b-button
					>
				</b-form-group>
			</div>
		</b-form>
		<AjaxTable
			permission-show="channel.show"
			id="sales-channel-groups-list"
			:filters="filters"
			:columns="modelColumns"
			resource="sales-channels-groups"
		>
			<template v-slot:cell(actions)="row">
				<div class="text-center">
					<b-button
						@click="
							event =>
								groupView(row.item, row.index, event)
						"
						type="button"
						size="sm"
						class="mr-1"
						variant="info"
						title="Editar grupo"
					>
						<md-icon icon="edit" />
					</b-button>
					<b-button
						@click="
							event =>
								manageChannels(row.item, row.index, event)
						"
						type="button"
						size="sm"
						class="mr-1"
						variant="success"
						title="Gestionar canales"
					>
						<md-icon icon="group_add" />
					</b-button>
					<b-button
						@click="
							event =>
								groupDelete(row.item, row.index, event)
						"
						v-if="$hasPermission('channel.delete')"
						type="button"
						size="sm"
						class="mr-1"
						variant="danger"
						title="Eliminar grupo"
					>
						<md-icon icon="delete" />
					</b-button>
				</div>
			</template>
		</AjaxTable>

		<!-- Modal for Group Edit -->
		<b-modal
			dialog-class="sx-modal-lg"
			hide-footer
			id="modal-group-edit"
			size="lg"
			:title="modalInfo.modelId > 0 ? 'Editar Grupo' : 'Nuevo Grupo'"
		>
			<GroupForm
				:model-id="modalInfo.modelId"
				@saved="onGroupSaved"
				@cancel="$bvModal.hide('modal-group-edit')"
			/>
		</b-modal>

		<!-- Modal for Channel Management -->
		<b-modal
			dialog-class="sx-modal-xl"
			hide-footer
			id="modal-channel-management"
			size="xl"
			:title="'Gestionar Canales - ' + selectedGroup.name"
		>
			<ChannelManagement
				:group-id="selectedGroup.id"
				:group-name="selectedGroup.name"
				@cancel="$bvModal.hide('modal-channel-management')"
				@refreshList="refreshTable"
			/>
		</b-modal>
	</div>
</template>

<script>
import AjaxTable from "../../../helpers/AjaxTable.vue";
import GroupForm from "./Single.vue";
import ChannelManagement from "./ChannelManagement.vue";
import api from "../../../../api.js";

export default {
	components: { AjaxTable, GroupForm, ChannelManagement },
	data() {
		return {
			modalInfo: {
				modelId: -1,
				title: "Grupo"
			},
			selectedGroup: {
				id: -1,
				name: ""
			},
			filters: {
				search: ""
			},
			modelColumns: [
				{ key: "id", label: "ID" },
				{ key: "name", label: "Nombre" },
				{ key: "description", label: "Descripción" },
				{ key: "channelsCount", label: "QTY canales" },
				{ key: "status", label: "Estado" },
				{ key: "actions", label: "Acciones" }
			]
		};
	},
	methods: {
		groupView(item) {
			this.modalInfo.modelId = item.id;
			this.$bvModal.show("modal-group-edit");
		},
		newGroup() {
			this.modalInfo.modelId = -1;
			this.$bvModal.show("modal-group-edit");
		},
		manageChannels(item) {
			this.selectedGroup = {
				id: item.id,
				name: item.name
			};
			this.$bvModal.show("modal-channel-management");
		},
		groupDelete(item) {
			this.$root.showWarning({
				message: `¿Está seguro que desea eliminar el grupo "${item.name}"?`,
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.delete(`/sales-channel-groups/${item.id}`)
						.then(() => {
							this.$root.showAlert("Grupo eliminado!", {
								variant: "warning"
							});
							this.$root.$emit(
								"bv::refresh::table",
								"sales-channel-groups-list"
							);
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},
		onGroupSaved() {
			this.$bvModal.hide("modal-group-edit");
			this.$root.$emit("bv::refresh::table", "sales-channel-groups-list");
		},
		refreshTable() {
			this.$root.$emit("bv::refresh::table", "sales-channel-groups-list");
		}
	}
};
</script>

<style></style>